window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

const dispatchToLivewire = (event, ...params) => {
    if (window.Livewire && typeof window.Livewire.dispatch === 'function') {
        window.Livewire.dispatch(event, params);
    } else if (window.livewire && typeof window.livewire.emit === 'function') {
        window.livewire.emit(event, ...params);
    }
};
window.dispatchToLivewire = dispatchToLivewire;

var pusher = new Pusher('58452c408103a11493d8', {
    cluster: 'eu'
  });

  var channel = pusher.subscribe('userStatus-channel');
  channel.bind('userStatus-event', function(data) {
    dispatchToLivewire('userActivity', data.status);
    // dispatchToLivewire('UserStatusUpdated', data.status);
  });

// window.Echo.channel('userStatus-channel') // Verify the correct channel name
// .listen('statusChange-event', (data) => {
//     console.log('Event received:', data.userID, data.status);
//     // Handle the real-time update here
// });
